import {
  Button,
  Form,
  //CompositionInput as Input,
  ModalFooter,
  TextArea,
} from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { redirectColumns } from './config';
import css from './css.module.less';
import ModalHOC from '@/src/constrains/ModalHOC';
import { Item as ItemWrapper, ModalContent } from 'src/components/Layouts';
import { checkMetaTag } from 'src/request/salesChannel/setting/digitalMarketing';
import { useParams } from 'react-router';
import { responseHandler } from 'src/tools/server';
// import { useDebounceFn } from 'ahooks';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
//const TextArea = Input;

const k = 'metaTagList';
const List = Form.List;

const randomNumber = () => {
  const d = new Date();
  const text = d.toString();
  return text;
};

const Meta = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { form } = props;
  const { modalOp } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const params: any = useParams();
  const { uuid } = params;
  const handleOnCheck = async (x, value) => {
    if (value) {
      const res = await checkMetaTag(uuid, { metaTag: value });
      const r = responseHandler(res);
      const { success, errMsg } = r || {};
      if (!success) {
        return Promise.reject(new Error(errMsg || `Format error`));
      }
    }
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      className={css.wrapper}
      title={getI18n('salesChannelDigitalMarketing.index.metaTag')}
      subtitle={`${getI18n(
        'salesChannelDigitalMarketing.index.metaTagTip',
      )}:  <html></html>, <script></script>, <iframe></iframe>, <form></form>, <img></img>, <video></video>, <a></a>, alert(“”).`}>
      <List name={[k]}>
        {(fields, { add, remove }, errors) => {
          // console.log('errors', errors);
          return (
            <React.Fragment>
              <EditableTable
                // id={tableId || 'SalesChannelDomainRedirectionTable' + id}
                dataSource={fields}
                id='SalesChannelMetaTagTable'
                pagination={false}
                columns={redirectColumns({
                  fields,
                  remove,
                  form,
                  onCheck: handleOnCheck,
                  getI18n,
                })}
                rowKey={(t) => {
                  //const [field] = t;
                  const name = get(t, 'name');
                  return name;
                }}
                scroll={{ x: 'max-content', y: 560 }}
              />
              <div className={css.btnsContainer} style={{ marginTop: 16 }}>
                <Button
                  type='primary'
                  onClick={() => {
                    setModalTitle(
                      getI18n('salesChannelDigitalMarketing.index.addMetaTag'),
                    );
                    setModalContent(
                      <AddMetaTag
                        onCancel={onModalCancel}
                        onCheck={handleOnCheck}
                        onAdd={(tag: string) => {
                          add({ _uuid: randomNumber(), metaTag: tag });
                          onModalCancel();
                        }}
                      />,
                    );
                    setShowModal(true);
                    // add({ _uuid: randomNumber(), metaTag: '' });
                  }}>
                  {getI18n('salesChannelDigitalMarketing.index.addTag')}
                </Button>
              </div>
            </React.Fragment>
          );
        }}
      </List>
    </SectionWrapper>
  );
};

const AddMetaTag = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onCancel, onAdd, onCheck } = props;
  const [form] = Form.useForm();
  // const { run: checkMeta } = useDebounceFn(
  //   async (x, value) => {
  //     if (value) {
  //       const res = await checkMetaTag(uuid, { metaTag: value });
  //       const r = responseHandler(res);
  //       const { success, errMsg } = r || {};
  //       if (!success) {
  //         return Promise.reject(new Error(errMsg || `Format error`));
  //       }
  //     }
  //   },
  //   {
  //     wait: 100,
  //   },
  // );
  // checkMetaTag(uuid, { metaTag: meta }).then((res) => {
  //   if (success) success();
  // });
  return (
    <React.Fragment>
      <ModalContent style={{ padding: '0 24px' }}>
        <ItemWrapper
          title='HTML'
          bottomTitle={`${getI18n(
            'salesChannelDigitalMarketing.index.metaTagTip',
          )}:  <html></html>, <script></script>, <iframe></iframe>, <form></form>, <img></img>, <video></video>, <a></a>, alert(“”).`}>
          <Form
            form={form}
            onFinish={(v) => {
              const { html } = v;
              onAdd(html);
            }}>
            <Item
              name='html'
              rules={[
                {
                  required: true,
                  message: getI18n(
                    'salesChannelDigitalMarketing.index.fieldRequired',
                  ),
                },
                {
                  validator: onCheck,
                },
              ]}>
              <TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
            </Item>
          </Form>
        </ItemWrapper>
      </ModalContent>
      <ModalFooter
        okText={getI18n('general.linkModule.Modal.add')}
        onOk={() => {
          form.submit();
        }}
        onCancel={onCancel}></ModalFooter>
    </React.Fragment>
  );
};

export default ModalHOC(Meta);
